export default {
  inboundChatIndicator: '{{name}} is typing',
  inboundAriaDefinitionText: 'from {{name}}:',
  outboundAriaDefinitionText: 'from me:',
  inboundMessageAriaLabel: 'Message from {{name}}, {{time}}',
  outboundMessageAriaLabel: 'Message from me, {{time}}',
};
